<div class="storage-account-down-toast">
    <div class="message">{{localize(langSection.Toast, langText.StorageAccountIsDown)}}</div>
</div>